import { Check } from "lucide-react";
import { USPS } from "@/lib/commerce";

/**
 * Centrale USP-balk — de enige plek waar de commerciële USP's worden
 * gerenderd. Gebruikt door zowel de desktop- als de mobiele header, zodat
 * elke pagina exact dezelfde tekst toont.
 *
 * Bron van de teksten: `USPS` in `src/lib/commerce.ts`.
 */
export function UspBar({ variant = "desktop" }: { variant?: "desktop" | "mobile" }) {
  if (variant === "mobile") {
    return (
      <div className="overflow-hidden border-b border-border/60 bg-white py-1.5">
        <div className="usp-marquee-track flex w-max" aria-label="Onze voordelen">
          {[0, 1].map((copy) => (
            <ul key={copy} className="flex shrink-0 gap-6 pr-6 text-[11px] text-foreground/80" aria-hidden={copy === 1}>
              {USPS.map((usp) => (
                <li key={usp} className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap">
                  <Check className="size-3 text-emerald-600" strokeWidth={3} />
                  {usp}
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="border-b border-border/60 bg-white py-2 text-center text-[13px] text-foreground/80">
      <ul className="inline-flex items-center gap-6" aria-label="Onze voordelen">
        {USPS.map((usp) => (
          <li key={usp} className="inline-flex items-center gap-1.5">
            <Check className="size-3.5 text-emerald-600" strokeWidth={3} />
            {usp}
          </li>
        ))}
      </ul>
    </div>
  );
}
